package com.platforma.chat_domain.use_case.chats

import com.platforma.chat_domain.MessageStatus
import com.platforma.chat_domain.model.ChatDomain
import com.platforma.chat_domain.model.TableMessageDomain
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.transform
import team.platforma.chat_data.model.ChatData
import team.platforma.chat_data.repository.chats.ChatsRepository
import team.platforma.chat_data.repository.messages.MokMessagesRepository
import kotlin.coroutines.coroutineContext

class TableChatsUseCase(
    private val chatsRepository: ChatsRepository
) {
    suspend fun insertChat(chatDomain: ChatDomain) {
        chatsRepository.insertChat(
            ChatData(
                id = chatDomain.id,
                userId = chatDomain.userId,
                aiModelId = chatDomain.aiModelId,
                name = chatDomain.name
            )
        )
    }

    fun observeAiChats(aiModelId: Long?, userId: Long): Flow<List<ChatDomain>> =
        chatsRepository.observeAiChats(aiModelId, userId).transform { value ->
           val list = value.map {
                ChatDomain(
                    id =it.id,
                    userId = it.userId,
                    aiModelId = it.aiModelId,
                    name = it.name
                )
            }
            return@transform emit(list)
        }

}